import { render, staticRenderFns } from "./BikyConfigErrorsItem.vue?vue&type=template&id=16980cec&scoped=true&"
import script from "./BikyConfigErrorsItem.vue?vue&type=script&lang=ts&"
export * from "./BikyConfigErrorsItem.vue?vue&type=script&lang=ts&"
import style0 from "./BikyConfigErrorsItem.vue?vue&type=style&index=0&id=16980cec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16980cec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
